import type { MouseEvent } from 'react'
import { resolveLibraryAddress } from './libraryAddress'
import { scrollAppToTop } from './appScroll'

/**
 * Whether a top-level navigation item's destination is the stop already on
 * screen (ADR-106 Q12). Library's destination is Mine — a tap on Library from
 * Catalog goes to Mine, it does not scroll Catalog (Q12(b)).
 */
export function isAtNavDestination(to: string, loc: { pathname: string; search: string }): boolean {
  if (to === '/home') return loc.pathname === '/home'
  if (to === '/progress') return loc.pathname === '/progress'
  if (to === '/library') {
    return loc.pathname === '/library' && resolveLibraryAddress(new URLSearchParams(loc.search)).seg === 'mine'
  }
  return false
}

/**
 * Click handler for a top-level navigation item: when its destination is the
 * stop already showing, scroll that stop to the top and do nothing else — no
 * navigation, no history entry, no state reset (ADR-106 Q12(a)). Otherwise the
 * link navigates as it always has, and the destination restores its own
 * remembered state (P4).
 */
export function onChainNavClick(to: string, loc: { pathname: string; search: string }) {
  return (e: MouseEvent) => {
    if (!isAtNavDestination(to, loc)) return
    e.preventDefault()
    scrollAppToTop()
  }
}
